module.exports = __webpack_public_path__ + "static/bvi-guetesiegel-gastmitglied-5973fa8983015737a57caa2cf9667a7a.jpg";